import React, { Component } from 'react';
import { connect } from 'react-redux'
import _ from 'lodash';

import { performRequest, setTag, setPage, clearResults } from './actions.mjs';


class ArticleTags extends Component {
    constructor(props) {
        super(props);
    }
    setTag(event, id) {
        event.preventDefault();
        document.activeElement.blur();
        this.props.dispatch(setTag(id));
        this.props.dispatch(setPage(0));
        this.props.dispatch(clearResults());
        this.props.dispatch(performRequest());
    }
    getClasses(tag) {
        if (this.props.tag === tag.id) {
            return 'btn-pill--pink active';
        }
        return 'btn-pill--pink';
    }
    render() {
		return (
		    <nav className="nav nav-filters justify-content-center m-b-lg d-none d-md-flex">
		        {this.props.tags.map(tag => {
		            return (
                        <a href="#" key={tag.id} onClick={(event) => this.setTag(event, tag.id)} className={this.getClasses(tag)}>{tag.name}</a>
		            );
		        })}
		    </nav>
		);
	}
}

function mapStateToProps(state) {
  return {
      tags: state.results.hitTags,
      tag: state.tag,
  };
}

export default connect(mapStateToProps)(ArticleTags);